import React from "react";

function ViewLocation({ data }) {

  return (

    <div className="custom-modal-body">

      <div className="model-custum">

        {/* HEADING */}
        <h3 className="mb-4">
          View Location
        </h3>

        <div className="view-details-grid">

          {/* LOCATION NAME */}
          <div className="view-detail-card">

            <span>
              Location Name
            </span>

            <h5>
              {data?.name || "N/A"}
            </h5>

          </div>

          {/* STATE NAME */}
          <div className="view-detail-card">

            <span>
              State Name
            </span>

            <h5>
              {data?.stateName || "N/A"}
            </h5>

          </div>

          {/* CITY NAME */}
          <div className="view-detail-card">

            <span>
              City Name
            </span>

            <h5>
              {data?.cityName || "N/A"}
            </h5>

          </div>

          {/* STATUS */}
          <div className="view-detail-card">

            <span>
              Status
            </span>

            <h5
              className={
                data?.status === "active"
                  ? "text-success"
                  : "text-danger"
              }
            >

              {
                data?.status === "active"
                  ? "Active"
                  : "Inactive"
              }

            </h5>

          </div>

          {/* CREATED DATE */}
          <div className="view-detail-card">

            <span>
              Created At
            </span>

            <h5>

              {
                data?.created_at

                  ? new Date(
                      data.created_at
                    ).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })

                  : "N/A"
              }

            </h5>

          </div>

          {/* UPDATED DATE */}
          <div className="view-detail-card">

            <span>
              Updated At
            </span>

            <h5>

              {
                data?.updated_at

                  ? new Date(
                      data.updated_at
                    ).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })

                  : "N/A"
              }

            </h5>

          </div>

        </div>

      </div>

    </div>
  );
}

export default ViewLocation;